// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b6167a89","332":"1257fa0e","455":"07422bed","977":"ac34a0b6"}[chunkId] + ".chunk.js";
};